module.exports = __webpack_public_path__ + "img/title2.80ee0a50.png";